<template>
  <el-form-item 
    :prop="'choose_gifts.'+keyId"
    :rules="[{ type: 'array', validator: checkGift, trigger: 'change' }]"
  >
    <div class="p-2 border rounded">
      <div>
        尚可選擇 <span>{{ $n(maxGiftQty) }}</span> 件贈品
        <span v-if="periodCount" class="text-muted">
          (贈品將於第 <span class="text-primary">{{ $n(periodCount) }}</span> 張訂單隨貨送出)
        </span>
      </div>

      <div class="row">
        <template v-for="gift_prod in chooseGifts">
          <template v-for="gift_assort in gift_prod.assorts">
            <div class="gift-item col-lg-3 col-md-3 col-sm-4 col-6 mb-2 p-2">
              <!-- 圖片 -->
              <div class="gift-item__img">
                <el-image 
                  :src="gift_assort?.image_url || gift_prod?.image_url" 
                  :alt="dt(gift_prod.name_translations)"
                  class="lazyload"
                >
                  <template #error>
                    <img src="/static/assets/front-end/img/image-place-holder.png" :alt="dt(gift_prod.name_translations)" style="width: 100%;">
                  </template>
                </el-image>
              </div>

              <!-- 名稱 -->
              <div class="gift-item__name">
                <div class="product-item__name-main">
                  <span>{{ dt(gift_prod.name_translations) }}</span>
                </div>
                <div class="gift-item__name-sub">
                  <span>{{ dt(gift_assort.name_translations) }}</span>
                </div>
              </div>

              <!-- 數量 -->
              <div class="gift-item__qty">
                <div v-if="gift_assort.status == 'shelves' && !!gift_assort.inventory" class="gift-item__qty-select">
                  <el-input-number
                    v-model="gift_assort.quantity"
                    :min=0
                    :max="gift_assort.inventory < maxGiftQty ? gift_assort.inventory : (maxGiftQty + gift_assort.quantity)"
                    :disabled="!gift_assort.quantity && !maxGiftQty"
                    class="w-100"
                  />
                </div>
                <div class="gift-item__qty-hint mt-1">
                  <span v-if="gift_assort.status != 'shelves'" class="text-danger">
                    {{ t("carts.ProductOff") }}
                  </span>
                  <span v-else-if="gift_assort.inventory <= 0" class="text-danger">
                    {{ t("carts.giveAwayDone") }}
                  </span>
                  <span v-else-if="gift_assort.inventory < 100">
                    {{ $t("carts.ProductRemaining", gift_assort.inventory, [gift_assort.inventory]) }}
                  </span>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </el-form-item>
</template>

<script setup>
import { reactive, ref, computed, onMounted, watch } from 'vue'
import { useI18n } from "vue-i18n"
import { useVModel } from "@vueuse/core"
import { dataTranslations as dt, currencyFormat, parseVideoTag, breakpoint } from "../utils"

const { t, n, locale } = useI18n()

const props = defineProps({
  data: {type: Array, default: () => []},
  periodCount: {type: Number, default: null},
  keyId: {type: String, default: "id"},
  maxQuantity: {type: Number, default: 1},
})
const emit = defineEmits(['update:data'])

const chooseGifts = useVModel(props, 'data', emit)

const maxGiftQty = computed(() => {
  let selected = 0

  if (chooseGifts.value.length) {
    // console.log("尚可選擇: ", props.maxQuantity)
    props.data.forEach((prod) => {
      // console.log("prod: ", prod)
      prod.assorts.forEach((assort) => {
        // console.log("assort: ", assort)
        if (assort?.quantity) {
          selected += assort.quantity
          // console.log("selected: ", selected)
        }
      })
    })
  }

  return props.maxQuantity - selected
})
const checkGift = (rule, value) => {
  if (maxGiftQty.value) {
    return Promise.reject(t('errors.pleaseSelect', [t("carts.gift")]))
  }

  return Promise.resolve()
}

</script>